import BaseModel from '../base/BaseModel.model';
import { ReportEvaluationState } from '@/enums/ReportEvaluationState';
import User from '../security/user.model';
import ResearchCenter from '../research/ResearchCenter/reseachCenter.model';
import { ProposalReportEvaluationType } from '@/enums/ProposalReportEvaluationType';
import BudgetItemEvaluation from './budgetItemEvaluation.model';
import AnalyticalMatrixEvaluation from '../analyticalMatrixEvaluation.model';
export default class PorposalUserReportEvaluations extends BaseModel {
    public evaluatorId?:number = 0;
    public porposalUserReportId?:number = 0;
    public amount?: number = 0;
    public description?: string = "";
    public reportDescription?: string = "";
    public state?: ReportEvaluationState;
    public deadline?: Date | null = null;
    public proposalId?: number | null = null;
    public reportOrderNumber?: number | null = null;
    public evaluator?:User = null;
    public stateDescription?:string = null;
    public proposalName?:string = '';
    public proposalCode?:string = '';
    public announcementTitle?:string = '';
    public announcementCode?:string = '';
    public documentTitle?:string = '';
    public document?:any = '';
    public projectEndDocument?:any = null;
    public researchCenter?:ResearchCenter = null;
    public proposalReportEvaluationType?:ProposalReportEvaluationType = ProposalReportEvaluationType.ReportEvaluation; 
    public budgetItemEvaluations:Array<BudgetItemEvaluation> = [];
    public analyticalMatrixEvaluations:Array<AnalyticalMatrixEvaluation> = [];
}